<script setup>
import { watch, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TableList from '@/components/lists/TableList.vue'
import PageNavigation from '@/components/navigate/PageNavigation.vue'
import Progress from '@/components/forms/Progress.vue'
import { useExportsStore } from '@/store/exports'
import { normalizeApiError } from '@/utils/apiError'

const store = useExportsStore()
const router = useRouter()
const route = useRoute()
const currentPage = ref(Number(route.query.page) || 1)
const type = ref('')
const errorMessage = ref('')

const titles = ref([
  { title: 'Id', key: 'id' },
  { title: 'Назва', key: 'name' },
  { title: 'Дата останнього оновлення', key: 'dateUpdate' },
])

async function loadExports(page = currentPage.value) {
  type.value = 'loading'
  errorMessage.value = ''

  try {
    await store.getExports(page)
    type.value = ''
  } catch (error) {
    type.value = 'error'
    errorMessage.value = normalizeApiError(error, {
      fallbackMessage: 'Не вдалося завантажити список вигрузок.',
    }).message
  }
}

onMounted(async () => {
  await loadExports()
})

watch(currentPage, async (newPage) => {
  await router.push({ query: { page: newPage } })
  await loadExports(newPage)
})
</script>

<template>
  <Progress :type="type" :error-message="errorMessage" loading-message="Завантаження списку..." />
  <TableList :rows="store.allExports" :titles="titles" detailRoutName="exportsDetail" blockTitle="Майданчики для продажу" />
  <PageNavigation v-model="currentPage" :totalPages="store.countPages" :maxVisible="5" />
</template>

<style scoped lang="scss">

</style>
